import {
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  AlertModule,
  TooltipModule,
} from 'axis-components';
import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { BaseRules, TextValues } from './district-of-columbia.model';
import { PipBaseStateComponent } from '../pip-base-state.component';
import { PersonalInjuryProtectionSelection } from '../../../config/pip-constants';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-district-of-columbia',
  templateUrl: './district-of-columbia.component.html',
  styleUrls: ['./district-of-columbia.component.scss'],
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    CommonModule,
    TruncateModule,
    TooltipModule,
  ],
})
export class DistrictOfColumbiaComponent extends PipBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('district-of-columbia', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('district-of-columbia', null);
    }
  }

  override dynamicRuleQueryBuilder(): string {
    if (
      this.baseRulesService.personalInjuryProtectionSelection ===
      PersonalInjuryProtectionSelection.IndividualStateCoverage
    ) {
      return 'ShowAll';
    }
  }
}
